import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export interface ShippingDetails {
    shippingaddress: string; // semicolon-separated: address1;address2;city;state;pincode
    lrno: string;
    vehicleno: string;
    transportername: string;
    deliverychallan: string;
}

@Injectable({
    providedIn: 'root'
})
export class FormDataService {
    private formDataSubject = new Subject<{
        currentDate: Date | null;
        empCode: string;
        storeCode: string;
        mobileNumber: string;
        customerName: string;
        salesRep: string;
        customerId?: number;
        isQuotationMode?: boolean;
        isSuspenseMode?: boolean;
        isWholesaleMode?: boolean;
        isOfferGroupMode?: boolean;
        isExchangeOrder?: boolean;
        isDeleteMode?: boolean;
        isDateEditMode?: boolean;
    }>();

    private shippingDetailsSubject = new BehaviorSubject<ShippingDetails>({
        shippingaddress: '',
        lrno: '',
        vehicleno: '',
        transportername: '',
        deliverychallan: ''
    });

    formData$ = this.formDataSubject.asObservable();
    shippingDetails$ = this.shippingDetailsSubject.asObservable();

    updateFormData(data: {
        currentDate: Date | null;
        empCode: string;
        storeCode: string;
        mobileNumber: string;
        customerName: string;
        salesRep: string;
        customerId?: number;
        isQuotationMode?: boolean;
        isSuspenseMode?: boolean;
        isWholesaleMode?: boolean;
        isOfferGroupMode?: boolean;
        isExchangeOrder?: boolean;
        isDeleteMode?: boolean;
        isDateEditMode?: boolean;
    }): void {
        this.formDataSubject.next(data);
    }

    updateShippingDetails(details: ShippingDetails): void {
        this.shippingDetailsSubject.next(details);
    }

    getShippingDetails(): ShippingDetails {
        return this.shippingDetailsSubject.value;
    }

    resetShippingDetails(): void {
        this.shippingDetailsSubject.next({
            shippingaddress: '',
            lrno: '',
            vehicleno: '',
            transportername: '',
            deliverychallan: ''
        });
    }

    getLatestFormData(): {
        currentDate: Date | null;
        empCode: string;
        storeCode: string;
        mobileNumber: string;
    } | null {
        // Since it's a Subject, it doesn't hold the last emitted value directly.
        // We'll rely on components subscribing to get updates.
        // If you need to get the *very last* value synchronously, consider BehaviorSubject with an initial value.
        return null;
    }
}